// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1E9BF5","secondary":"#00BCA2","highlight":"#fe6f61","success":"#01c987","warning":"#ffa000","danger":"#ff5050","light":"#EAEFF9","dark":"#222"};